import { dataInstance } from './axiosInstance';

/**
 * Create an audit log entry (non-blocking).
 * Intended actions: 'claim' | 'drop' | 'create' | 'delete'
 * Required core fields for pickup/drop:
 *  - action
 *  - coach_name
 *  - start_time (ISO)
 *  - end_time (ISO)
 * Optional:
 *  - coach_email
 *  - class_type
 *  - event_id
 *  - meta (object)
 */
export const logAuditEvent = async (log) => {
  try {
    const res = await dataInstance.post('/admin/audit-logs', log);
    return res.data;
  } catch (e) {
    // Logging should never break user flow
    console.error('Failed to log audit event:', e);
    return null;
  }
};

/**
 * Fetch audit logs with optional filters.
 * Params:
 *  - startDate (ISO string)
 *  - endDate (ISO string)
 *  - coachName (string)
 *  - classType (string)
 *  - action ('claim' | 'drop' | 'create' | 'delete')
 *  - page (number)
 *  - pageSize (number)
 * Returns: Array or paginated result, depending on backend.
 */
export const fetchAuditLogs = async (params = {}) => {
  const {
    startDate,
    endDate,
    coachName,
    classType,
    action,
    page = 1,
    pageSize = 50,
  } = params;

  try {
    const res = await dataInstance.get('/admin/audit-logs', {
      params: {
        start_date: startDate,
        end_date: endDate,
        coach_name: coachName,
        class_type: classType,
        action,
        page,
        page_size: pageSize,
      },
    });
    return res.data;
  } catch (e) {
    console.error('Failed to fetch audit logs:', e);
    throw e;
  }
};
